import * as _Int from "../settings/interfaces";
import { drag } from "./main";

let card: HTMLDivElement;

let swipeLeftBtn: HTMLElement;
let swipeRightBtn: HTMLElement;
let swipeUpBtn: HTMLElement;
let swipeDownBtn: HTMLElement;

const test = false;

let callback: (...args: any) => void;

function click(dir: string): () => void {
  return () => {
    if (!drag.now) {
      callback(dir);
    }
  };
}

export function addClickable(el: HTMLDivElement, handler: (...args: any) => void): void {

  card = el;
  callback = handler;

  swipeLeftBtn = card.querySelector(`[data-swipe="left"]`) as HTMLElement;
  swipeRightBtn = card.querySelector(`[data-swipe="right"]`) as HTMLElement;
  swipeUpBtn = card.querySelector(`[data-swipe="top"]`) as HTMLElement;
  swipeDownBtn = card.querySelector(`[data-swipe="bottom"]`) as HTMLElement;

  [swipeLeftBtn, swipeRightBtn, swipeDownBtn, swipeUpBtn].forEach((btn) => {

    if (btn) {
      const dir = btn.getAttribute("data-swipe") as string;
      btn.addEventListener("click", click(dir));
    }

  });

}